
    import * as React from 'react';

    const Next16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M9.13 3.51L9.644 3 15 8l-5.355 5-.516-.51 4.427-4.134H1v-.712h12.556z" /></svg>
        </div>
      );
    };

    Next16.displayName = 'Next16';

    export default Next16;
  